import React, { useEffect } from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { ROUTES } from "@/config/site";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import AdminApp from "@/admin/AdminApp";
import Home from "@/pages/Home";
import Ydelser from "@/pages/Ydelser";
import Indsatser from "@/pages/Indsatser";
import IndsatsDetail from "@/pages/IndsatsDetail";
import FindForloeb from "@/pages/FindForloeb";
import Kommuner from "@/pages/Kommuner";
import Akut from "@/pages/Akut";
import Udsatte from "@/pages/Udsatte";
import Adhd from "@/pages/Adhd";
import Autisme from "@/pages/Autisme";
import Kontakt from "@/pages/Kontakt";
import Privatliv from "@/pages/Privatliv";
import Cookies from "@/pages/Cookies";
import NotFound from "@/pages/NotFound";

const PAGES = {
  home: Home, ydelser: Ydelser, indsatser: Indsatser, findforloeb: FindForloeb,
  kommuner: Kommuner, akut: Akut, udsatte: Udsatte, adhd: Adhd, autisme: Autisme,
  kontakt: Kontakt, privatliv: Privatliv, cookies: Cookies,
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AppRoutes = () => (
  <Routes>
    {ROUTES.map((r) => {
      const C = PAGES[r.key];
      const en = r.path === "/" ? "/en" : `/en${r.path}`;
      return (
        <React.Fragment key={r.key}>
          <Route path={r.path} element={<C />} />
          <Route path={en} element={<C />} />
        </React.Fragment>
      );
    })}
    <Route path="/indsatser/:slug" element={<IndsatsDetail />} />
    <Route path="/en/indsatser/:slug" element={<IndsatsDetail />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

function App() {
  useLenis();
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <LanguageProvider>
            <ScrollToTop />
            <Routes>
              <Route
                path="/admin/*"
                element={<AdminApp />}
              />
              <Route
                path="*"
                element={
                  <>
                    <Seo />
                    <Navbar />
                    <main>
                      <AppRoutes />
                    </main>
                    <Footer />
                  </>
                }
              />
            </Routes>
            <Toaster position="top-center" richColors />
          </LanguageProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
